import {Component, OnInit, Inject} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {MainService} from "../../Services/service.service";
import {UserService} from "../../Services/user.service";
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-validate-phone',
  templateUrl: './validate-phone.component.html',
  styleUrls: ['./validate-phone.component.css']
})
export class ValidatePhoneComponent implements OnInit {
  get currentUserPhone(): string {
    return this._currentUserPhone;
  }

  set currentUserPhone(value: string) {
    this._currentUserPhone = value;
  }

  private data;
  constructor(private route: ActivatedRoute, public userService: UserService, public mainService: MainService, @Inject(MAT_DIALOG_DATA) data,public dialogRef: MatDialogRef<ValidatePhoneComponent>) {
    this.data = data
  }

  performPhoneValidation($event: MouseEvent) {
    this._validationInProgress = true;
    this.userService.validatePhone(this.currentUserId, this.validationCode).then(res => { 
       this.dialogRef.close();
      this.mainService.route.navigate(["/"]);
    
     
       this.mainService.showInformation('Phone validation succeeded');
      this.mainService.showLogin(undefined,"Your registration succeeded ! Please log in...");
    }).catch(result => {
      this._validationInProgress = false;
      this.validationCode="";
      this.mainService.showError(result);
    })
  }

  get currentUserId(): number {
    return this._currentUserId;
  }

  set currentUserId(value: number) {
    this._currentUserId = value;
  }

  private _currentUserId: number = 0;
  private _currentUserPhone: string = '';

  ngOnInit() {
    const userDataObject = this.data.userData

    if (userDataObject) {
      this.currentUserId = parseInt(userDataObject.userId);
      this.currentUserPhone = userDataObject.userPhone;
      this.sendPhoneValidationSms(null)
    }
  }

  private _validationCode: string = "";

  get validationCode(): string {
    return this._validationCode;
  }

  get sendingInProgress(): boolean {
    return this._sendingInProgress;
  }

  set sendingInProgress(value: boolean) {
    this._sendingInProgress = value;
  }

  set validationCode(value: string) {
    this._validationCode = value;
  }

  private _validationInProgress: boolean = false;
  private _sendingInProgress: boolean = false;

  public get allowPerformValidation(): boolean {
    return !this._validationInProgress && this._validationCode.length == 6;
  }

  public get validationInProgress(): boolean {
    return this._validationInProgress;
  }

  sendPhoneValidationSms(event: MouseEvent) {

    this.sendingInProgress = true;
    this.userService.sendPhoneValidationMessage(this.currentUserId).then(res => {
      this.sendingInProgress = false;

    }).catch(res => {
      this.sendingInProgress = false;
      this.mainService.showError(res);
    })
  }

  public afterRegClose:boolean = false
  public firstSendConfirmed:boolean = false
}
